import { render, staticRenderFns } from "./SuperChatEvents.vue?vue&type=template&id=d3091c6a&scoped=true&lang=pug&"
import script from "./SuperChatEvents.vue?vue&type=script&lang=ts&"
export * from "./SuperChatEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3091c6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/arc-one/_www/millsta-ready/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3091c6a')) {
      api.createRecord('d3091c6a', component.options)
    } else {
      api.reload('d3091c6a', component.options)
    }
    module.hot.accept("./SuperChatEvents.vue?vue&type=template&id=d3091c6a&scoped=true&lang=pug&", function () {
      api.rerender('d3091c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/SuperChatEvents.vue"
export default component.exports